<template>
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">{{ item.id ? 'Edit' : 'New' }} salary history<br>
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to areas & groups list"
              @click="$router.push({name: 'researcher.administration.salary-history.index'})"
            ><i data-feather="chevron-left" /></a>
            <a
              v-if="loggedUser.roles.includes('super-admin')"
              class="btn btn-icon btn-flat-secondary"
              @click="$store.dispatch('modals/toggleRequestModal', 'SalaryHistory')"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>

      <div class="content-body content-body--senior-call">
        <div
          v-if="errors != ''"
          class="alert alert-danger mt-1 p-1"
        >
          {{ errors }}
        </div>
        <div class="row">
          <div class="col-12">
            <SearchResearcher :item="item" />

            <div class="card">
              <div
                v-b-toggle="`collapseContent`"
                class="card-header"
              >
                <h3 class="cart-title">
                  <a data-action="collapse">Content</a>
                </h3>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li>
                      <a data-action="collapse"><i data-feather="chevron-down" /></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-content collapse show">
                <b-collapse
                  :id="`collapseContent`"
                  visible
                >
                  <!-- sólo se muestra "show" si hay texto en el textarea -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.reason'] }}</label>
                          <input
                            v-model="item.reason"
                            type="text"
                            class="form-control"
                          >
                        </div>
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.comments'] }}</label>
                          <quill-editor v-model="item.comments" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.salary_date'] }}</label>
                          <date-picker
                            v-model="item.new_salary_level_date"
                            format="D MMM Y"
                            value-type="format"
                            class="w-100"
                          />
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >{{ labels['content.levels'] }}</label>
                          <input
                            v-model="item.levels"
                            type="number"
                            class="form-control"
                          >
                        </div>
                      </div>
                      <div
                        v-if="item.user"
                        class="col-sm-6"
                      >
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >Promotion history related</label>
                          <v-select
                            v-model="item.promotion_history"
                            label="title"
                            :options="histories"
                            :get-option-key="option => option.title"
                          />
                        </div>
                      </div>
                    </div>
                    <template
                      v-if="loggedUser.roles.includes('super-admin')"
                    >
                      <hr>
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="mb-1">
                            <h5>{{ labels['content.confirm'] }}</h5>
                            <div class="form-check form-check-success form-switch d-flex align-items-center">
                              <input
                                id=""
                                v-model="item.confirm"
                                type="checkbox"
                                class="form-check-input"
                              >
                              <label
                                class="form-check-label"
                                for=""
                              ><small class="ms-1">{{ item.confirm ? 'Yes' : 'No' }} </small></label> <!-- cambia a yes si se marca -->
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="mb-1">
                            <h5>Is visible by the researcher?</h5>
                            <div class="form-check form-check-success form-switch d-flex align-items-center">
                              <input
                                id=""
                                v-model="item.visible_researcher"
                                type="checkbox"
                                class="form-check-input"
                              >
                              <label
                                class="form-check-label"
                                for=""
                              ><small class="ms-1">{{ item.visible_researcher ? 'Yes' : 'No' }} </small></label> <!-- cambia a yes si se marca -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </b-collapse>
              </div>
            </div>

            <IcreaRemarks
              :item="item"
            />

            <AddFile
              :id="6"
              :title="'Support documentation'"
              :type="4"
              :files="item.files_"
            />

            <InternalNotes
              :notes="item.notes"
              @saveNewNote="saveNewNote"
            />

            <AttachedForm
              :type="'SalaryHistory'"
              :model-id="salaryId"
            />
          </div>
        </div>

        <div class="page-actions">
          <button
            v-if="!sending"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" />
            <span class="ms-25 align-middle">Save and Exit</span>
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { BCollapse } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import InternalNotes from '@/views/back/partials/components/InternalNotes.vue'
import DatePicker from 'vue2-datepicker'
import IcreaRemarks from '@/views/back/partials/components/IcreaRemarks.vue'
import AddFile from '../../../admin/senior-call/components/AddFile.vue'
import SearchResearcher from '../../../partials/components/SearchResearcher.vue'
import 'vue2-datepicker/index.css'
import AttachedForm from '../../../forms/partials/AttachedForm.vue'

export default {
  components: {
    AddFile,
    SearchResearcher,
    InternalNotes,
    IcreaRemarks,
    DatePicker,
    BCollapse,
    AttachedForm,
  },
  data() {
    return {
      salaryId: this.$route.params.id,
      sending: false,
      errors: '',
    }
  },
  computed: {
    ...mapGetters({
      item: 'salaryHistories/item',
      histories: 'promotionHistory/items',
      loggedUser: 'auth/admin',
      labels: 'sectionLabels/itemLabels',
      user: 'users/user',
      attached: 'requestForms/attached',
    }),
  },
  watch: {
    'item.user': function () {
      this.$store.dispatch('promotionHistory/filter', { researcher: this.item.user })
    },
  },
  async mounted() {
    this.$store.dispatch('sectionLabels/fetchLabels', 'administration.salary_history')
    if (this.salaryId) {
      await this.$store.dispatch('salaryHistories/fetchId', this.salaryId)
      this.$store.dispatch('promotionHistory/filter', { researcher: this.item.user })
    } else {
      await this.$store.dispatch('salaryHistories/cleanType')
      Vue.set(this.item, 'user', this.user)
    }
  },
  methods: {
    optionLabel(option) {
      return option.promotion.title
    },
    saveFiles(files) {
      this.item.files_ = files.data
    },
    async save() {
      this.sending = true
      this.item.attached_form = this.attached
      try {
        if (this.salaryId) {
          await this.$store.dispatch('salaryHistories/update', { id: this.salaryId, data: this.item })
        } else {
          await this.$store.dispatch('salaryHistories/create', this.item)
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.item.id) {
        Vue.swal('The Salary history has been saved correctly!', '', 'success').then(() => {
          this.$router.push({ name: 'researcher.administration.salary-history.index' })
        })
      } else {
        // Vue.swal
      }

      this.sending = false
    },
    saveNewNote(note) {
      this.item.notes.push(note)
    },
    async onSearch(search, store) {
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
  },
}
</script>
